// @ts-strict-ignore
import isNumber from 'lodash/isNumber';
import type {Point, Series} from 'highcharts';

import {TooltipFormatterParams} from 'common/charts/visualization/pie-chart/types';
import {truncateMiddle} from 'common/util/string';
import {TooltipItemType} from 'common/components/chart-tooltip/types';
import {commaizeNumber} from 'common/util';
import {renderChartTooltipToString} from 'common/components/chart-tooltip/render-chart-tooltip-to-string';

export function defaultTooltipFormatter({name, value, percent, color}: TooltipFormatterParams): string {
  const formatPercent = (decimal) => {
    return Math.round(decimal * Math.pow(10, 2)) / Math.pow(10, 2) + `%`;
  };

  const sections = [
    {
      rows: [
        {
          items: [
            {
              text: truncateMiddle(name, 45),
              type: TooltipItemType.Strong,
            },
          ],
        },
      ],
    },
    {
      rows: [
        {
          items: [
            {
              text: isNumber(value) ? commaizeNumber(value) : ``,
              type: TooltipItemType.Data,
            },
          ],
        },
        {
          items: [
            {
              text: isNumber(percent) ? formatPercent(percent) : ``,
              type: TooltipItemType.Data,
            },
            {
              text: `of total`,
              type: TooltipItemType.Text,
            },
          ],
        },
      ],
    },
  ];

  return renderChartTooltipToString({titleColor: color, sections});
}

/**
 * Updates the "hover" state of a pie chart
 * There's a bug in highcharts where setting the state doesn't
 * correctly update styling for each slice, the workaround is
 * to set opacity manually
 * @see https://github.com/highcharts/highcharts/issues/11750
 */
export function setPieSeriesState(state: `hover` | `normal`, series: Series, hoveredPoints: Point[] = []) {
  const isHovering = state === `hover`;

  // updates all points in the chart
  series.data.forEach((point) => {
    point.graphic.element.style[`opacity`] = isHovering ? `0.3` : `1`;
    point.setState(isHovering ? `inactive` : `normal`);
  });

  hoveredPoints?.forEach((point) => {
    point.graphic.element.style[`opacity`] = `1`;
    point.setState(`hover`);
  });
}
